import React, { memo } from 'react';
import Link from 'next/link';
import { LinkConvertorType } from './analytics/hocs/withTrackableNavLinkComponent';

const GatsbyButtonConvertor = memo(({ to, href, children, ...props }: LinkConvertorType) => {
  const slug = href || to;
  return (
    <Link href={slug} {...props} passHref legacyBehavior>
      {children}
    </Link>
  );
});
GatsbyButtonConvertor.displayName = 'ButtonConvertor';

export default GatsbyButtonConvertor;
